import type { ErrorInfo } from 'react';
import { Component } from 'react';

interface ErrorBoundaryProps {
  children: JSX.Element;
}

interface ErrorBoundaryState {
  error?: Error;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override readonly state: ErrorBoundaryState = {};

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  // eslint-disable-next-line class-methods-use-this -- no use for `this`
  override componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // eslint-disable-next-line no-console -- log error to console
    console.error({ error, errorInfo });
  }

  override render() {
    const { children } = this.props;
    const { error } = this.state;

    return error ? null : children;
  }
}
